import { TextArea } from '@lbcamden/lib-react';
import { nanoid } from 'nanoid';
import { FunctionComponent, ReactNode, useMemo } from 'react';

import { ConditionalFormInput, ConditionalFormInputProps } from '../ConditionalFormInput';
import { TextAreaField } from './ConditionalTextArea.styled';

export interface ConditionalTextAreaProps extends Omit<
  ConditionalFormInputProps<string>,
  'initialYesValue'
> {
  textAreaId?: string;
  textAreaLabel?: ReactNode;
  errorOnEmpty?: boolean;
}

export const ConditionalTextArea: FunctionComponent<ConditionalTextAreaProps> = ({
  textAreaId: textAreaIdProp,
  textAreaLabel = 'Please specify',
  errorOnEmpty,
  ...props
}) => {
  const textAreaId = useMemo(() => textAreaIdProp || nanoid(), [textAreaIdProp]);

  const { value, disabled, onChange } = props;

  const isTrue = typeof value === 'string';

  return (
    <ConditionalFormInput {...props} initialYesValue="">
      {isTrue && (
        <TextAreaField label={textAreaLabel} labelFor={textAreaId}>
          <TextArea
            $error={errorOnEmpty && !value}
            id={textAreaId}
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
          />
        </TextAreaField>
      )}
    </ConditionalFormInput>
  );
};
